import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useFinishChallenge = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (challengeId) => {
      const result = await restClient({
        url: `${prefix}/challenge/finish`,
        method: 'post',
        data: {
          id: challengeId
        }
      });
      return result;
    },
  });
};